









import {Component, Vue} from 'vue-property-decorator';
import Search from '@/components/Search.vue';
import ContactUs from '@/components/ContactUs.vue';

@Component({
	components: {
		'v-search': Search,
		'v-contact-us': ContactUs
	}
})
export default class Help extends Vue {
}
